import { useEffect } from "react";

export function useWindowEvent<K extends keyof WindowEventMap>(type: K, listener: (this: Window, ev: WindowEventMap[K]) => any) {
    useEffect(() => {
        window.addEventListener(type, listener, { capture: true });
        return () => window.removeEventListener(type, listener, { capture: true });
    }, [listener, type]);
}

export function useDocumentEvent<K extends keyof DocumentEventMap>(type: K, listener: (this: Document, ev: DocumentEventMap[K]) => any) {
    useEffect(() => {
        document.addEventListener(type, listener, { capture: true });
        return () => document.removeEventListener(type, listener, { capture: true });
    }, [listener, type]);
}